import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi } from '@/modules';
import { BloodManagementService } from '@/modules/surgicalEvent';
import { BloodManagement } from './bloodManagement.model';
import { wrapError } from '../../error';

const bloodManagementApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    bloodManagement: builder.query<BloodManagement, PatientId>({
      queryFn: ({ patientId }) =>
        BloodManagementService.getInstance(patientId).fetch().catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'BloodManagement', id: patientId }
      ]
    }),

    patchBloodManagement: builder.mutation<
      BloodManagement,
      WithPatientId<Partial<BloodManagement>>
    >({
      queryFn: ({ patientId, ...bloodManagement }) =>
        BloodManagementService.getInstance(patientId)
          .patch(bloodManagement)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'BloodManagement', id: patientId },
        'Dashboard'
      ]
    })
  }),
  overrideExisting: false
});

export const { useBloodManagementQuery, usePatchBloodManagementMutation } =
  bloodManagementApi;
